import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

export const linkClickBeacon = () => ({
  hitType: HIT_TYPE.EVENT,
  eventCategory: EVENT_CATEGORIES.BROWSE,
  eventName: EVENT_NAMES.LINK_CLICK,
  linkID: 'embed_button',
});
